export default __webpack_public_path__ + "static/media/mixkit-software-interface-back-2575.10c53455.mp3";